import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ compact = false, mall = false, onLight = false }) => (
  <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
    <div className="relative w-10 h-10 rounded-xl gold-gradient flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform">
      <span className="font-heading font-black text-xl text-navy-900 leading-none">G</span>
    </div>
    <div className="leading-none">
      <div className={`font-heading font-extrabold text-lg tracking-tight ${onLight ? "text-forest-800" : "text-white"}`}>
        GENESIS <span className={onLight ? "saffron-text" : "gold-text"}>{mall ? "MALL" : "GROUP"}</span>
      </div>
      {!compact && (
        <div className={`text-[8px] uppercase tracking-[0.18em] mt-0.5 whitespace-nowrap ${onLight ? "text-terracotta-600" : "text-gold/70"}`}>
          {mall ? "by Genesis Group" : "All-in-One Business Center"}
        </div>
      )}
    </div>
  </Link>
);
